import { createApp } from 'vue';
import App from './App.vue';
import './assets/backgrounds/cloudtile.jpg';
import './assets/backgrounds/worn_dots.jpg';
import '../global.css';

createApp(App).mount('#app');
